import GenericController from './../generic.controller'

export default class Controller extends GenericController {

    constructor(...args) {

        super(...args);
        this._statisticGraphChartBindToName = 'PanelInfoChart';
        // this._statisticGraphChartBindToName = 'THPchartFromMainBar';
        this.loading = true;
        this.connectionType = {1: 'Ethernet', 2: 'Wi-fi', 3: 'GSM'};
        this.wifiGoodRssi = -60
        this.wifiOkRssi = -85
        this.gsmGoodRssi = -75
        this.gsmOkRssi = -90

        this._PanelsService.getConnectionInfo(this.panelId).then(r => {
            this.connectionInfo = this.connectionType[r.data.interface];
        }).catch(e => {
            this.connectionInfoFail = true;

        }).finally(r => this.setLoadingState());

        this._PanelsService.getEthernetInfo(this.panelId).then(r => {
            this.ethernet = r.data;
        }).catch(e => {
            this.ethernetFail = true;
        }).finally(r => this.setLoadingState());

        this._PanelsService.getGsmInfo(this.panelId).then(r => {
            this.gsm = r.data;
        }).catch(e => {
            this.gsmFail = true;
        }).finally(r => this.setLoadingState());

        this._PanelsService.getWifiInfo(this.panelId).then(r => {
            this.wifi = r.data;
        }).catch(e => {
            this.wifiFail = true;
        }).finally(r => this.setLoadingState());

        this._PanelsService.getRadioInfo(this.panelId).then(r => {
            this.radio = r.data;
        }).catch(e => {
            this.radioFail = true;
        }).finally(r => this.setLoadingState());

    }

    setLoadingState() {
        this.loading = !(this.ethernet || this.ethernetFail &&
            this.gsm || this.gsmFail &&
            this.wifi || this.wifiFail &&
            this.radio || this.radioFail)
    }

    resetPanelConnection() {
        this._PanelsService.resetPanelConnection(this.panelId);
    }

    getRadioValue(key, value) {

        if (key == 'freq') {
            return _.floor(value / 1000000, 3);
        }
        return value;
    }

    isObjectNotEmpty(obj) {
        return !_.isEmpty(obj);
    }

    loadChosenGraph(graphTypeStr, graphTitle, offset = 0) {
        this.graphTitle = graphTitle;
        this.showModal('connectionGraphModal');
        this.setCurrentDeviceStatisticsParams(graphTypeStr);
        let measurementsFuncPointer = null
        if (graphTitle === 'Wi-Fi') {
            this.goodRssiLevel = this.wifiGoodRssi;
            this.okRssiLevel = this.wifiOkRssi;
            measurementsFuncPointer = this.getWifiConnectionMeasurements
        } else if (graphTitle === 'GSM') {
            this.goodRssiLevel = this.gsmGoodRssi;
            this.okRssiLevel = this.gsmOkRssi;
            measurementsFuncPointer = this.getGSMConnectionMeasurements
        }

        //timeout for modal loading
        setTimeout(() => {
            this.genericLoadGraph(this._statisticGraphChartBindToName, graphTypeStr, measurementsFuncPointer, offset);
        }, 200);
    }

}


/** WEBPACK FOOTER **
 ** ./src/main/panels/panel/panelInfo.component/controller.js
 **/